module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/tag-179c178727e226b574cad6fd716d03e5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/tag.svg
// module id = 0wOK
// module chunks = 24